import {
  COMPANY_NAME_PLACEHOLDER,
  DOCUMENT_LIST_PLACEHOLDER,
  PORTAL_LINK_PLACEHOLDER,
} from './OnboardingEmailModal.templates';
import { OnboardingEmailTemplate, OnboardingTemplateDocument } from './OnboardingEmailModal.types';

export const normalizeDocumentName = (name: string): string =>
  name.trim().toLowerCase().replace(/\s+/g, ' ');

export const namesMatch = (left: string, right: string): boolean => {
  const a = normalizeDocumentName(left);
  const b = normalizeDocumentName(right);
  if (!a || !b) {
    return false;
  }
  return a === b || a.includes(b) || b.includes(a);
};

export const formatCombinedEmail = (subject: string, body: string): string => {
  const trimmedSubject = subject.trim();
  const trimmedBody = body.trim();
  if (trimmedSubject && trimmedBody) {
    return `Subject: ${trimmedSubject}\n\n${trimmedBody}`;
  }
  return trimmedSubject ? `Subject: ${trimmedSubject}` : trimmedBody;
};

export const formatDocumentList = (documents: OnboardingTemplateDocument[]): string =>
  documents
    .map((document, index) => {
      const description = document.description?.trim();
      const line = description ? `${document.name} [${description}]` : document.name;
      return `${index + 1}. ${line}`;
    })
    .join('\n');

export const composeOnboardingEmail = ({
  template,
  companyName,
  portalLink,
  requestedDocuments,
}: {
  template: OnboardingEmailTemplate;
  companyName?: string | null;
  portalLink: string;
  requestedDocuments: OnboardingTemplateDocument[];
}): string => {
  const body = template.emailBody
    .replaceAll(COMPANY_NAME_PLACEHOLDER, companyName?.trim() || 'there')
    .replaceAll(DOCUMENT_LIST_PLACEHOLDER, formatDocumentList(requestedDocuments))
    .replaceAll(PORTAL_LINK_PLACEHOLDER, portalLink);

  return formatCombinedEmail(template.emailSubject, body);
};
